const Hero = () => {
    return (
        <>
            <section id="inicio" className="hero-pattern min-h-screen flex items-center relative pt-20 overflow-hidden">

                {/* Blobs de fondo */}
                <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full pointer-events-none"
                    style={{ background: 'radial-gradient(circle, rgba(124,58,237,0.18) 0%, transparent 70%)', filter: 'blur(60px)' }} />
                <div className="absolute bottom-1/4 right-1/4 w-80 h-80 rounded-full pointer-events-none"
                    style={{ background: 'radial-gradient(circle, rgba(139,92,246,0.12) 0%, transparent 70%)', filter: 'blur(60px)' }} />

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-20">
                    <div className="max-w-3xl">

                        {/* Badge */}
                        <span className="inline-flex items-center gap-2 py-1.5 px-4 rounded-full bg-brand-500/15 text-brand-400 font-semibold text-sm mb-8 border border-brand-500/25"
                            style={{ backdropFilter: 'blur(10px)' }}>
                            <span className="w-2 h-2 rounded-full bg-brand-400 inline-block" style={{ animation: 'pulse 2s ease-in-out infinite' }} />
                            El Sistema Operativo de tu Negocio
                        </span>

                        <h1 className="text-4xl md:text-6xl font-black text-white leading-tight mb-6 tracking-tight">
                            Gestiona tu negocio con{' '}
                            <span className="text-brand-400">inteligencia real</span>
                        </h1>

                        <p className="text-lg md:text-xl text-white/55 mb-10 max-w-2xl leading-relaxed">
                            Inventario en tiempo real, agenda automatica, historial de clientes y facturacion rapida.
                            Una sola plataforma para cualquier negocio que quiere crecer sin perder el control.
                        </p>

                        {/* Nichos */}
                        <div className="flex flex-wrap gap-2 mb-10">
                            {['Talleres', 'Salones', 'Clinicas', 'Gimnasios', 'Veterinarias', 'Restaurantes', 'Tiendas', 'Y mas...'].map(n => (
                                <span key={n} className="glass text-white/50 text-xs font-semibold px-3 py-1.5 rounded-full">
                                    {n}
                                </span>
                            ))}
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4">
                            <a href="#contacto"
                                className="bg-gradient-to-r from-brand-600 to-brand-500 text-white px-8 py-4 rounded-full font-bold text-lg text-center flex items-center justify-center gap-2 shadow-2xl shadow-brand-600/40 hover:opacity-90 hover:scale-105 transition-all group">
                                Registrar mi Negocio
                                <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
                                </svg>
                            </a>
                            <a href="#servicios"
                                className="glass text-white px-8 py-4 rounded-full font-semibold text-lg text-center hover:bg-white/10 transition-all">
                                Ver Funciones
                            </a>
                        </div>

                        {/* Stats */}
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mt-16 pt-8 border-t border-white/8">
                            <div>
                                <h4 className="text-3xl font-black text-white mb-1">Cero</h4>
                                <p className="text-white/40 text-sm">Perdidas por productos no cobrados</p>
                            </div>
                            <div>
                                <h4 className="text-3xl font-black text-white mb-1">100%</h4>
                                <p className="text-white/40 text-sm">Control de stock en tiempo real</p>
                            </div>
                            <div className="hidden md:block">
                                <h4 className="text-3xl font-black text-white mb-1">1 clic</h4>
                                <p className="text-white/40 text-sm">De cotizacion a factura</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tarjeta flotante decorativa */}
                <div className="hidden lg:block absolute right-12 top-1/2 -translate-y-1/2 z-10">
                    <div className="glass rounded-2xl p-5 w-56 shadow-2xl mb-4">
                        <p className="text-white/40 text-xs font-bold uppercase tracking-wider mb-1">Citas hoy</p>
                        <p className="text-white text-2xl font-black mb-1">24 <span className="text-green-400 text-sm font-bold">+6</span></p>
                        <div className="w-full bg-white/10 rounded-full h-1.5 mt-2">
                            <div className="bg-gradient-to-r from-brand-500 to-brand-400 h-1.5 rounded-full" style={{ width: '72%' }} />
                        </div>
                    </div>
                    <div className="glass rounded-2xl p-5 w-56 shadow-2xl">
                        <p className="text-white/40 text-xs font-bold uppercase tracking-wider mb-1">Ingresos del mes</p>
                        <p className="text-white text-2xl font-black">$8.4M <span className="text-green-400 text-sm font-bold">↑ 22%</span></p>
                    </div>
                </div>
            </section>

            {/* WhatsApp FAB */}
            <a href="https://wa.me/573164344145" target="_blank" rel="noopener noreferrer"
                className="fixed bottom-6 right-6 text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-all duration-300 z-50 flex items-center justify-center"
                style={{ background: 'linear-gradient(135deg, #16a34a, #22c55e)', boxShadow: '0 8px 32px rgba(34,197,94,0.45)' }}
                aria-label="Escribenos por WhatsApp">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16" className="w-7 h-7">
                    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c-.003 1.396.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"/>
                </svg>
            </a>
        </>
    );
};

export default Hero;
